<template>
    <div class="toast-container">
        <div class="toast" v-show="show">
            <div class="toast-container">
                <img v-if="iconUrl" :src="iconUrl" class="toast-picture"/>
                <div class="close" @click="closeToast"></div>
                <div class="toast-title">{{titleTxt}}</div>
                <div class="toast-btn">
                    <div class="toast-cancel" @click="closeToast">关闭</div>
                </div>
            </div>
        </div>
        <div class="toast-mask" v-show="show"></div>
    </div>
</template>

<script>
    export default {
        name: "Toast",
        data() {
            return {
                show: this.visible,
                titleTxt: this.title,
                contentTxt: this.content,
                iconName: this.icon,
            }
        },
        props: {
            title: {
                type: String
            },
            content: {
                type: String
            },
            icon: {
                type: String
            }
        },
        visible: {
            type: Boolean,
            default() {
                return false
            }
        },
        methods: {
            closeToast() {
                this.show = false
            }
        },
        watch: {
            visible(to, from) {
                this.show = to
            },
            title(to, from) {
                this.titleTxt = to
            },
            icon(to, from) {
                this.iconName = to
            }
        },
        computed: {
            toastTitle() {
                return this.prize && this.prize.level > 0
                    ? "恭喜您，获得" +
                    this.prize.name
                    : "谢谢参与";
            },
            toastIcon() {
                return this.prize && this.prize.level > 0
                    ? require("../../static/img/" + this.icon + ".png")
                    : require("../../static/img/" + this.icon + ".png");
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Toast.vue?c8b25a12